export const AVAILABLE_FROM_PARAMETERS = [
  // форма регистрации в шапке или по дефолту
  'default',

  // вебинары специалистов
  'specialist_webinars',

  // программа прозрение специалистов
  'specialist_provision',

  // лендинг /p1inlove/
  // Old 'p1inlove-p1-3991',
  'p1inlove-5683',

  // digift
  'region_promo_5136',

  // t30-trial
  't30-trial',

  // t30sample
  't30sample-7013'
];
